export let AgMemberFieldsJSON = {
  "1624697545242-date": {
    elementid: 1624697545242,
    elementtype: "date",
    "database-label": "dn_dateofbirt",
    "display-required": 1,
    attributemasterid: 357,
    "display-fieldlabel": "Date of Birth",
    "display-labelposition": "placeholder",
  },
  "1625733914550-date": {
    elementid: 1625733914550,
    elementtype: "date",
    "database-label": "dn_pracsinc_1",
    "display-required": 1,
    attributemasterid: 358,
    "display-fieldlabel": "Practicing Since",
    "display-labelposition": "placeholder",
  },
  "1624703938549-email": {
    elementid: 1624703938549,
    elementtype: "email",
    "database-label": "dn_emaiidprim",
    "display-required": 1,
    attributemasterid: 359,
    "display-fieldlabel": "Email ID (Primary)",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "placeholder",
  },
  "1624703942272-email": {
    elementid: 1624703942272,
    elementtype: "email",
    "database-label": "dn_emaiidalte",
    attributemasterid: 360,
    "display-fieldlabel": "Email ID (Alternate)",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "placeholder",
  },
  "1624697533254-customSelect": {
    elementid: 1624697533254,
    elementtype: "customSelect",
    "database-label": "dn_gender",
    "data-datasource": "masterlist",
    "display-tooltip": "TT",
    "data-customvalue": "optionA#optionB#optionC#optionD",
    "display-required": 1,
    attributemasterid: 361,
    "display-fieldlabel": "Gender",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "placeholder",
  },
  "1624704105599-customSelect": {
    elementid: 1624704105599,
    elementtype: "customSelect",
    "database-label": "dn_highqual",
    "data-datasource": "masterlist",
    "data-customvalue": "optionA#optionB#optionC#optionD",
    "display-required": 1,
    attributemasterid: 362,
    "display-fieldlabel": "Highest Qualification",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "placeholder",
  },
  "1624704941877-customSelect": {
    elementid: 1624704941877,
    elementtype: "customSelect",
    "database-label": "dn_ownership",
    "data-datasource": "customvalues",
    "data-customvalue": "Own#Practicing ",
    "display-required": 1,
    attributemasterid: 363,
    "display-fieldlabel": "Ownership",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "placeholder",
  },
  "1624704946038-customSelect": {
    elementid: 1624704946038,
    elementtype: "customSelect",
    "database-label": "dn_type",
    "data-datasource": "customvalues",
    "data-customvalue": "Hospital#Clinic#Nursing Home",
    "display-required": 1,
    attributemasterid: 364,
    "display-fieldlabel": "Type",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "placeholder",
  },
  "1624704996494-number": {
    elementid: 1624704996494,
    elementtype: "number",
    "database-label": "dn_numbofbeds",
    "display-required": 1,
    attributemasterid: 365,
    "display-fieldlabel": "Number of Beds",
    "display-labelposition": "placeholder",
  },
  "1624705005678-number": {
    elementid: 1624705005678,
    elementtype: "number",
    "database-label": "dn_apprcounofempl",
    attributemasterid: 366,
    "display-fieldlabel": "Approx. count of employees ",
    "display-labelposition": "placeholder",
  },
  "1624705254690-customSelect": {
    elementid: 1624705254690,
    elementtype: "customSelect",
    "database-label": "dn_imabranname",
    "data-datasource": "masterlist",
    "data-customvalue": "optionA#optionB#optionC#optionD",
    "display-required": 1,
    attributemasterid: 367,
    "display-fieldlabel": "IMA Branch Name",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "placeholder",
  },
  "1625734325899-number": {
    elementid: 1625734325899,
    elementtype: "number",
    "database-label": "dn_pincode",
    "display-required": 1,
    attributemasterid: 368,
    "display-fieldlabel": "Pincode",
    "display-labelposition": "placeholder",
  },
  "1625734415860-customSelect": {
    elementid: 1625734415860,
    elementtype: "customSelect",
    "database-label": "dn_state",
    "data-datasource": "masterlist",
    "data-customvalue": "optionA#optionB#optionC#optionD",
    "display-required": 1,
    attributemasterid: 369,
    "display-fieldlabel": "State",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "placeholder",
  },
  "1625734418506-customSelect": {
    elementid: 1625734418506,
    elementtype: "customSelect",
    "database-label": "dn_city",
    "data-datasource": "masterlist",
    "data-customvalue": "optionA#optionB#optionC#optionD",
    "display-required": 1,
    attributemasterid: 370,
    "display-fieldlabel": "City",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "placeholder",
  },
  "1626085207511-customSelect": {
    elementid: 1626085207511,
    elementtype: "customSelect",
    "database-label": "dn_currdesiinima_1",
    "data-datasource": "masterlist",
    "data-customvalue": "optionA#optionB#optionC#optionD",
    attributemasterid: 371,
    "display-fieldlabel": "Current Designation in IMA",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "placeholder",
  },
  "1626085252987-customSelect": {
    elementid: 1626085252987,
    elementtype: "customSelect",
    "database-label": "dn_pastdesiinima_1",
    "data-datasource": "masterlist",
    "data-customvalue": "optionA#optionB#optionC#optionD",
    attributemasterid: 372,
    "display-fieldlabel": "Past Designation in IMA",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "placeholder",
  },
  "1626173406294-number": {
    elementid: 1626173406294,
    elementtype: "number",
    "database-label": "dn_pincode_1",
    "display-required": 1,
    attributemasterid: 373,
    "display-fieldlabel": "Pincode",
    "display-labelposition": "placeholder",
  },
  "1626173413159-customSelect": {
    elementid: 1626173413159,
    elementtype: "customSelect",
    "database-label": "dn_state_1",
    "data-datasource": "masterlist",
    "data-customvalue": "optionA#optionB#optionC#optionD",
    "display-required": 1,
    attributemasterid: 374,
    "display-fieldlabel": "State",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "placeholder",
  },
  "1626173461113-customSelect": {
    elementid: 1626173461113,
    elementtype: "customSelect",
    "database-label": "dn_city_1",
    "data-datasource": "masterlist",
    "data-customvalue": "optionA#optionB#optionC#optionD",
    "display-required": 1,
    attributemasterid: 375,
    "display-fieldlabel": "City",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "placeholder",
  },
  "1624697220665-columns": {
    elementid: 1624697220665,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1624697264531-columns": {
    elementid: 1624697264531,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1624703923683-columns": {
    elementid: 1624703923683,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1624703997729-columns": {
    elementid: 1624703997729,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1624704091813-columns": {
    elementid: 1624704091813,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1624704391892-columns": {
    elementid: 1624704391892,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1624704914838-columns": {
    elementid: 1624704914838,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1624704929949-columns": {
    elementid: 1624704929949,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1624704935471-columns": {
    elementid: 1624704935471,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1624705231112-columns": {
    elementid: 1624705231112,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1624705234852-columns": {
    elementid: 1624705234852,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1625734253225-columns": {
    elementid: 1625734253225,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1625734404457-columns": {
    elementid: 1625734404457,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1626173324188-columns": {
    elementid: 1626173324188,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1626173358255-columns": {
    elementid: 1626173358255,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1624704019883-textarea": {
    elementid: 1624704019883,
    elementtype: "textarea",
    "database-label": "dn_corraddr",
    "display-rows": "2",
    "display-required": 1,
    attributemasterid: 376,
    "display-fieldlabel": "Correspondence Address",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "placeholder",
  },
  "1624704111143-textarea": {
    elementid: 1624704111143,
    elementtype: "textarea",
    "database-label": "dn_spechighqualifothe",
    "display-rows": "2",
    "display-required": 0,
    attributemasterid: 377,
    "display-fieldlabel": "Specify Highest Qualification (if other)",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "placeholder",
  },
  "1624705014487-textarea": {
    elementid: 1624705014487,
    elementtype: "textarea",
    "database-label": "dn_hospaddr",
    "display-rows": "2",
    "display-required": 1,
    attributemasterid: 378,
    "display-fieldlabel": "Hospital Address",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "placeholder",
  },
  "1624697288049-textfield": {
    elementid: 1624697288049,
    elementtype: "textfield",
    // "database-label": "dn_firsname",
    "database-label": "dn_firsname",
    "display-tooltip": "",
    "display-required": 1,
    attributemasterid: 379,
    "display-fieldlabel": "First Name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "placeholder",
  },
  "1624697291931-textfield": {
    elementid: 1624697291931,
    elementtype: "textfield",
    "database-label": "dn_lastname",
    "display-required": 0,
    attributemasterid: 380,
    "display-fieldlabel": "Last Name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "placeholder",
  },
  "1624704400175-textfield": {
    elementid: 1624704400175,
    elementtype: "textfield",
    "database-label": "dn_collnamembbs",
    "display-required": 1,
    attributemasterid: 381,
    "display-fieldlabel": "College Name (MBBS)",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "placeholder",
  },
  "1624704991448-textfield": {
    elementid: 1624704991448,
    elementtype: "textfield",
    "database-label": "dn_name",
    "display-required": 1,
    attributemasterid: 382,
    "display-fieldlabel": "Hospital Name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "placeholder",
  },
  "1624705250484-textfield": {
    elementid: 1624705250484,
    elementtype: "textfield",
    "database-label": "dn_imareginumb",
    "display-required": 1,
    attributemasterid: 383,
    "display-fieldlabel": "IMA Registration Number",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "placeholder",
  },
  "1625058231955-textfield": {
    elementid: 1625058231955,
    elementtype: "textfield",
    "database-label": "dn_mobile",
    "display-required": 1,
    attributemasterid: 384,
    "display-fieldlabel": "Mobile",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "placeholder",
  },
  "1625734264498-textfield": {
    elementid: 1625734264498,
    elementtype: "textfield",
    "database-label": "dn_mobialte",
    attributemasterid: 385,
    "display-fieldlabel": "Mobile (Alternate)",
    "validation-maxlength": "10",
    "validation-minlength": "10",
    "display-labelposition": "placeholder",
  },
};
